import cloneDeep from 'lodash/cloneDeep';

export const filterTeachingMaterialsByProducts = (allTeachingMaterials = [], userProducts = []) => {
  let teachingMaterials = cloneDeep(allTeachingMaterials);
  teachingMaterials = teachingMaterials.filter((material) => {
    try {
      const existsProduct = userProducts.find((product) => {
        return product.code == material.productCode;
      });
      if (existsProduct) {
        return true;
      }
    } catch {
      return false;
    }
    return false;
  });

  return teachingMaterials;
};
